module.exports = __webpack_public_path__ + "static/media/lithium.973fd6d0.svg";